// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'

import styled from 'styled-components';

import ContentWrapper from '../components/ContentWrapper';
import PageHeader from '../components/PageHeader';

const FullFillContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`

class SeasonRegistrationPage extends Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  render() {
    const { profile={} } = this.props
    const link= `https://forms.fillout.com/t/biECWf7u2Qus?embed=true&firstname=${profile.firstname}&lastname=${profile.lastname}&email=${profile.email}&tel=${profile.tel}`;
    return (
        <FullFillContainer>
          <iframe src={link}></iframe>
        </FullFillContainer>
    )
  }
}

export default compose(
  firebaseConnect((props, store) => ([
  ])),
  connect(({firebase, firebase: {data, auth, profile}}) => {
    return {
      profile
    }
  }),
)(SeasonRegistrationPage)
